import { config } from '@/config';

(async () => {
  await config.fetchConfig();
  const { app } = await import('./bootloader');
  await import('./plugins');
  const store = await import('./store');
  const router = await import('./router');
  app.use(store.default);
  app.use(router.default);
  app.mount('#app');
})();
